/* eslint-disable implicit-arrow-linebreak */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useTemplatesOtherConfigs() {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'templatesSettingsConfigs' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    isFetched,
    ...rest
  } = useQuery(
    [namespace],
    () =>
      okapiKy
        .get(
          'inventory-templates-configs?query=(configName==templatesSettings)',
        )
        .json(),
    { enabled: true },
  );

  return {
    isLoading,
    isFetched,
    isError,
    refetch,
    templatesSettings: !isLoading ? data?.templatesConfigs[0]?.configValue : {},
    configId: !isLoading ? data?.templatesConfigs[0]?.id : undefined,
    rest,
  };
}

export default useTemplatesOtherConfigs;
